<template>
  <div class="col-xs-12 col-md-3">
    <form-group-search-select
      ref="input"
      :label="label"
      :readonly="readonly"
      :value="value"
      :name="name"
      :options="options"
      :data-vv-as="label"
      :placeholder="placeholder"
      @input="$emit('input', $event)"
      @change="$emit('input', $event)"
      v-validate="{ required: required }"
    />
  </div>
</template>

<script>
export default {
  name: "c-protocolo-bolsista",
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator"],
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean
  },
  mounted() {
    this.$el.value = this.value;
  },
  computed: {
    options() {
      return [
        {
          value: "Não",
          text: "Não"
        },
        {
          value: "FEI",
          text: "FEI"
        },
        {
          value: "Fies",
          text: "Fies"
        },
        {
          value: "Prouni - 50%",
          text: "Prouni - 50%"
        },
        {
          value: "Prouni - 100%",
          text: "Prouni - 100%"
        },
        {
          value: "Outros",
          text: "Outros"
        }
      ];
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/Campos/Bolsista.vue